// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  align-items: center;
  color: #ababab;
  display: flex;
  font-size: 16px;
  height: 600px;
  justify-content: center;
  width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/Components/Error/Error.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb","sourcesContent":[".error-container {\n  align-items: center;\n  color: #ababab;\n  display: flex;\n  font-size: 16px;\n  height: 600px;\n  justify-content: center;\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
